import { render } from "./HomeLabComponent.vue?vue&type=template&id=062a0310&scoped=true&ts=true"
import script from "./HomeLabComponent.vue?vue&type=script&lang=ts"
export * from "./HomeLabComponent.vue?vue&type=script&lang=ts"

import "./HomeLabComponent.vue?vue&type=style&index=0&id=062a0310&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-062a0310"]])

export default __exports__